import {
  takeOverWessalConversation,
  wessalConversationId,
} from './useWessalHumanControl';
import {
  hasProjectedWessalAssignee,
  isExactWessalComposerAssignee,
  WESSAL_COMPOSER_ASSIGNEE_REQUIRED,
  WESSAL_COMPOSER_FOREIGN_ASSIGNEE,
} from './wessalComposerOwnership';

export {
  isExactWessalComposerAssignee,
  WESSAL_COMPOSER_ASSIGNEE_REQUIRED,
  WESSAL_COMPOSER_FOREIGN_ASSIGNEE,
} from './wessalComposerOwnership';

export async function ensureWessalHumanComposerControl(input: {
  readonly conversation: Readonly<Record<string, unknown>>;
  readonly customerVisible: boolean;
  readonly workspaceAccountId: string | number;
  readonly workspaceUserId: string | number;
}): Promise<void> {
  if (!input.customerVisible || !wessalConversationId(input.conversation))
    return;
  if (
    !isExactWessalComposerAssignee(input.conversation, input.workspaceUserId)
  ) {
    throw new Error(
      hasProjectedWessalAssignee(input.conversation)
        ? WESSAL_COMPOSER_FOREIGN_ASSIGNEE
        : WESSAL_COMPOSER_ASSIGNEE_REQUIRED
    );
  }
  const control = await takeOverWessalConversation(
    input.conversation,
    { accountId: input.workspaceAccountId, userId: input.workspaceUserId },
    'HUMAN_COMPOSER_SEND'
  );
  if (!control || control.mode !== 'HUMAN') {
    throw new Error('Wessal human control was not acknowledged; send blocked.');
  }
}
